class FourOFourController {}

export default FourOFourController;



// WEBPACK FOOTER //
// ./client/app/four-o-four/four-o-four.controller.js